module.exports = __webpack_public_path__ + "img/gp_main02_text_m.0d5467f3.svg";